type Props = {
  score: number;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
};

export function ScoreRing({ score, label = 'Nyaman', size = 'md' }: Props) {
  const safe = Math.max(0, Math.min(100, score));
  const angle = safe * 3.6;
  return (
    <div
      className={`score-ring score-ring--${size}`}
      style={{ '--score-angle': `${angle}deg` } as React.CSSProperties}
      aria-label={`Comfort Score ${safe}, ${label}`}
    >
      <div className="score-ring__inner">
        <strong>{safe}</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}
